<template>
  <b-container>
    <div v-if="!stripeConnectUserId" class="text-center">
      <b-row class="mt-3 justify-content-center">
        <b-alert show variant="danger" class="text-center">
          <h4>
            {{ $t('StripeConnectInfo.stripeNotConnected') }}
            <font-awesome-icon icon="exclamation-triangle"/>
          </h4>
          <router-link :to="{name: 'StripeConnectStart'}">{{ $t('StripeConnectInfo.stripeSetupLink') }}</router-link>
        </b-alert>
      </b-row>
    </div>

    <div v-else>
      <b-row class="mt-3 justify-content-center">
        <b-alert show variant="success" class="text-center">
          <h3>
            {{ $t('StripeConnectInfo.stripeConnected') }}
            <font-awesome-icon icon="check-circle"/>
          </h3>
        </b-alert>
      </b-row>
      <b-row class="mt-3 justify-content-left">
        <h4>{{ $t('StripeConnectInfo.stripeConnectedResponsibilities') }}</h4>
      </b-row>
      <b-row class="mt-3 justify-content-left">
        <ul class="text-left">
          <li>{{ $t('StripeConnectInfo.stripeConnectedItem1') }}</li>
          <li>{{ $t('StripeConnectInfo.stripeConnectedItem2') }}</li>
          <li>{{ $t('StripeConnectInfo.stripeConnectedItem3') }}</li>
          <li>{{ $t('StripeConnectInfo.stripeConnectedItem4') }}</li>
        </ul>
      </b-row>
    </div>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'StripeConnectInfo',
  computed: {
    ...mapGetters({ stripeConnectUserId: 'stripeConnectUserId' })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StripeConnectInfo.vue